import NestedForm from "stimulus-rails-nested-form"

// Index aléatoire : les clés de nested attributes doivent être des entiers
// pour être acceptées par strong parameters (hash à clés entières = collection)
const newChildIndex = () => Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString()

export default class extends NestedForm {
    add(e) {
        e.preventDefault()

        const html = new DOMParser().parseFromString(this.templateTarget.innerHTML.replace(/NEW_RECORD/g, newChildIndex()), "text/html").querySelector("div")

        html.dataset.lineItemDataValue = JSON.stringify(e.detail)

        this.targetTarget.insertAdjacentHTML('beforebegin', html.outerHTML)
    }

    remove(event) {
        event.preventDefault()

        if (window.confirm("Vous allez supprimer cette ligne")) {
            super.remove(event)
        }
    }
}